export const formatCurrency = (value) => {
    return `$ ${value.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ".")}`;
};

export const formatCurrencyWithNull = (value) => {
    if (typeof value !== 'number' || isNaN(value)) {
        return '$ 0'; // Manejo de valores inválidos o indefinidos
    }
    return `$ ${value.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ".")}`;
};


export const extractNumber = (value) => {
    return parseFloat(value.replace(/[^\d.-]/g, ''));
};

export const formatDisplayName = (name) => {
    if (!name) return '';
    // return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
    return name
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
};

export const formatEmail = (email) => {
    const [localPart, domain] = email.split('@');
    const capitalizedLocalPart = localPart.charAt(0).toUpperCase() + localPart.slice(1);
    return (
        <>
            {capitalizedLocalPart}
            <wbr />
            @{domain}
        </>
    );
};

export const subsidyNames = {
    general: 'General',
    sep: 'SEP',
    pie: 'PIE',
    eib: 'EIB',
    maintenance: 'Mantenimiento',
    retention: 'Pro Retención',
    internship: 'Internado',
    reinforcement: 'Reforzamiento',
    faep: 'FAEP'
};

export const getSubventionNames = (subsidies) => {
    return Object.entries(subsidies)
        .filter(([_, value]) => value > 0)
        .map(([key, _]) => subsidyNames[key])
        .join(' | ');
};

export const getSubventionNames2 = (subsidies) => {
    return Object.entries(subsidies)
        .filter(([_, value]) => value > 0)
        .map(([key, _]) => subsidyNames[key])
        .join(' | ');
};

export const getCurrentDate = () => {
    const date = new Date();
    return `${date.getDate().toString().padStart(2, '0')}-${date.toLocaleString('es', { month: 'short' })}-${date.getFullYear().toString().slice(-2)}`;
};

export const formatDate = (timestamp) => {
    if (!timestamp) return '';

    const date = timestamp.toDate();
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Los meses en JavaScript son base 0
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    return `${day}/${month}/${year} ${hours}:${minutes}`;
};

export const formatDateJS = (timestamp) => {
    if (!timestamp) return '';

    const date = new Date(timestamp);

    // Verificar si la fecha es válida
    if (isNaN(date.getTime())) {
        return '';
    }

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
};

export const getStateLabel = (state) => {
    switch (state) {
        case 'pending':
            return 'Pendiente';
        case 'rejected':
            return 'Rechazada';
        case 'approved':
            return 'Aprobada';
        case 'finished':
            return 'Terminada';
        default:
            return 'Desconocido';
    }
};

export const getTypePurchase = (state) => {
    switch (state) {
        case 'purchase':
            return 'Compras';
        case 'serviceContract':
            return 'Contrato de Servicios';
        case 'feeContract':
            return 'Contrato de Honorarios';
        case 'payment':
            return 'Pago'
        default:
            return 'Desconocido';
    }
};

export const getDepartmentURL = (state) => {
    switch (state) {
        case 'Departamento Sep':
            return 'sep';
        case 'Departamento UTP':
            return 'utp';
        case 'Departamento Finanzas':
            return 'finanzas';
        case 'Departamento Adquisiciones':
            return 'adquisiciones';
        case 'Departamento Jurídico':
            return 'jurídico';
        case 'Departamento Control Interno':
            return 'controlInterno';
        case 'Departamento Tesorería':
            return 'tesorería'
        default:
            return 'sep';
    }
};

export const getFullDepartmentName = (name) => {
    const departmentNames = {
        'Departamento SEP': 'Departamento de Subvenciones',
        'Departamento UTP': 'Departamento Unidad Técnica Pedagógica',
        'Departamento Finanzas': 'Departamento de Finanzas',
        'Departamento Adquisiciones': 'Departamento de Adquisiciones',
        'Departamento Jurídico': 'Departamento Jurídico',
        'Departamento Control Interno': 'Departamento de Control Interno',
        'Departamento Tesorería': 'Departamento de Tesorería'
    };
    return departmentNames[name] || name;
};

export const getUpdatedEffectiveExpense = (formData) => {

    const newEffectiveExpense = formData.totalSubsidyAmount - formData.accruedExpense - formData.accruedBalance;

    return newEffectiveExpense;

};

export const getUpdatedEffectiveBalance = (formData) => {

    const newEffectiveBalance = formData.totalSubsidyAmount - formData.accruedBalance;

    return newEffectiveBalance;

};

// Función auxiliar para ordenar notificaciones
export const sortNotificationsByDate = (notifications) => {
    return [...notifications].sort((a, b) => {
        const dateA = a.notificationCreated?.toMillis() || 0;
        const dateB = b.notificationCreated?.toMillis() || 0;
        return dateB - dateA;
    });
};

// Función auxiliar para ordenar notificaciones de Solicitudes
export const sortNotificationsByDate2 = (requests) => {
    return [...requests].sort((a, b) => {
        const dateA = (a.typeOfRequest === 'payment'
            ? a.created?.toMillis?.()
            : a.requestDetails?.created?.toMillis?.()) || 0;

        const dateB = (b.typeOfRequest === 'payment'
            ? b.created?.toMillis?.()
            : b.requestDetails?.created?.toMillis?.()) || 0;

        return dateB - dateA;
    });
};

export const getSentTo = (request) => {
    // Si es una solicitud de pago, el sentTo está en la raíz
    if (request.typeOfRequest === 'payment') {
        return request.sentTo;
    }
    // Para otros tipos de solicitud, el sentTo está en requestDetails
    return request.requestDetails?.sentTo;
};

export const preventNonNumericInput = (e) => {
    if (e.key === '.' || e.key === ',' || e.key === '-' || e.key === 'e') {
        e.preventDefault();
    }
};

// Función para formatear RUT chileno
export const formatRut = (rut) => {
    // Limpiar el rut de cualquier formato previo
    let cleaned = rut.replace(/[^0-9kK]/g, '');

    if (cleaned.length > 1) {
        // Separar el dígito verificador
        const dv = cleaned.slice(-1);
        let numbers = cleaned.slice(0, -1);

        // Formatear la parte numérica
        let formatted = '';
        while (numbers.length > 3) {
            formatted = '.' + numbers.slice(-3) + formatted;
            numbers = numbers.slice(0, -3);
        }
        formatted = numbers + formatted;

        // Agregar el guión y dígito verificador
        return formatted + '-' + dv;
    }

    return cleaned;
};

export const getEstablishment = ({ userData, dataSearch, establishmentList }) => {
    const establishmentId = (userData && userData?.dimension === 'Establecimiento')
        ? userData.establishmentId
        : dataSearch.establishment.id;

    return establishmentList.find(establishment => establishment.id === establishmentId);
};

export const getEstablishmentWithId = (establishmentId, establishmentList) => {
    return establishmentList.find(establishment => establishment.id === establishmentId);
};

export function sumSubsidies(subsidies) {
    let totalSum = 0;

    for (let key in subsidies) {
        for (let month in subsidies[key]) {
            for (let code in subsidies[key][month]) {
                totalSum += subsidies[key][month][code];
            }
        }
    }

    return totalSum;
}

export function sumSalaryExpense(salaryExpense) {
    let totalSum = 0;

    for (let key in salaryExpense) {
        const monthlyDistribution = salaryExpense[key].monthlyDistribution;
        for (let month in monthlyDistribution) {
            for (let code in monthlyDistribution[month]) {
                totalSum += monthlyDistribution[month][code];
            }
        }
    }

    return totalSum;
}

export function sumAccruedBalance(pme) {
    return pme.activities.reduce((total, activity) => {
        return total + (activity.accruedBalance || 0);
    }, 0);
}

export const calculateSubsidyTotals = (subsidies, selectedSubsidy) => {
    if (selectedSubsidy.value === 'all') {
        return sumSubsidies(subsidies);
    }

    let totalSum = 0;
    for (let key in subsidies) {
        if (key === selectedSubsidy.value) {
            for (let month in subsidies[key]) {
                for (let code in subsidies[key][month]) {
                    totalSum += subsidies[key][month][code];
                }
            }
        }
    }
    return totalSum;
};

export const calculateActivitySubsidyPercentage = (activity, selectedSubsidy) => {
    if (selectedSubsidy.value === 'all') {
        return activity.accruedBalance || 0;
    }

    // Calcular el porcentaje basado en la proporción de la subvención seleccionada
    const subsidyAmount = activity.subsidies[selectedSubsidy.value] || 0;
    const totalAmount = activity.totalSubsidyAmount || 0;

    if (totalAmount === 0) return 0;

    const percentage = subsidyAmount / totalAmount;
    return (activity.accruedBalance || 0) * percentage;
};

export const calculateSalaryExpenseBySubsidy = (salaryExpense, selectedSubsidy) => {
    if (!salaryExpense) return 0;

    let totalSum = 0;

    for (let key in salaryExpense) {
        // Verificar si la subvención coincide con la seleccionada
        if (selectedSubsidy.value === 'all' ||
            salaryExpense[key].activitySubsidies.toLowerCase() === selectedSubsidy.value.toLowerCase()) {
            const monthlyDistribution = salaryExpense[key].monthlyDistribution;
            for (let month in monthlyDistribution) {
                for (let code in monthlyDistribution[month]) {
                    totalSum += monthlyDistribution[month][code];
                }
            }
        }
    }

    return totalSum;
};

// Función para obtener el saldo del año anterior
export const getPreviousYearBalance = (pmeList, establishmentId, currentYear) => {
    const previousYearPME = pmeList?.find(p =>
        p.establishmentId === establishmentId &&
        p.yearPME === currentYear - 1
    );

    if (!previousYearPME) return "No Ingresado";

    return formatCurrency(
        sumSubsidies(previousYearPME.incomeFromSubsidies) -
        (sumAccruedBalance(previousYearPME) + sumSalaryExpense(previousYearPME.salaryExpense))
    );
};

export const isProjectActive = (idProject, dataProjects) => {
    const project = dataProjects.find(project => project.id === idProject);
    if (!project || !project.contractValidity || !Array.isArray(project.contractValidity) || project.contractValidity.length === 0) {
        return false;
    }

    const { dateFrom, dateUntil } = project.contractValidity[0];

    if (!dateFrom || !dateUntil) {
        return false;
    }

    const currentDate = new Date();
    const startDate = new Date(dateFrom);
    const endDate = new Date(dateUntil);
    return currentDate >= startDate && currentDate <= endDate;
};